import React from 'react';
import { Table, Button, Badge } from 'react-bootstrap';
import moment from 'moment';

export const BillTable = ({ bills, onDelete, onEdit, onStatusChange }) => {
    const getStatusBadge = (status) => {
        const statusStyles = {
            paid: 'success',
            pending: 'warning',
            overdue: 'danger'
        };
        return <Badge bg={statusStyles[status] || 'secondary'}>{status}</Badge>;
    };

    const isOverdue = (dueDate) => {
        return moment(dueDate).isBefore(moment(), 'day');
    };

    return (
        <Table responsive hover className="table-striped">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Category</th>
                    <th>Amount</th>
                    <th>Due Date</th>
                    <th>Status</th>
                    <th>Type</th>
                    <th>Description</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {bills.map((bill) => (
                    <tr key={bill.id}>
                        <td>{bill.name}</td>
                        <td>
                            <span className="badge bg-primary">
                                {bill.category}
                            </span>
                        </td>
                        <td>${parseFloat(bill.amount).toFixed(2)}</td>
                        <td>
                            {moment(bill.dueDate).format('MMM DD, YYYY')}
                            {isOverdue(bill.dueDate) && bill.status !== 'paid' && (
                                <Badge bg="danger" className="ms-2">Overdue</Badge>
                            )}
                        </td>
                        <td>{getStatusBadge(bill.status)}</td>
                        <td>
                            <span className={`badge bg-${bill.recurring ? 'info' : 'secondary'}`}>
                                {bill.recurring ? 'Recurring' : 'One-time'}
                            </span>
                        </td>
                        <td>{bill.description}</td>
                        <td>
                            <div className="d-flex gap-2">
                                {bill.status === 'pending' || bill.status === 'overdue' ? (
                                    <>
                                        <Button 
                                            variant="outline-success" 
                                            size="sm"
                                            className="btn-icon"
                                            onClick={() => onStatusChange(bill.id, 'paid')}
                                        >
                                            <i className="ri-checkbox-circle-line"></i>
                                        </Button>
                                        <Button 
                                            variant="outline-primary" 
                                            size="sm"
                                            className="btn-icon"
                                            onClick={() => onEdit(bill)}
                                        >
                                            <i className="ri-pencil-line"></i>
                                        </Button>
                                    </>
                                ) : null}
                                <Button 
                                    variant="outline-danger" 
                                    size="sm"
                                    className="btn-icon"
                                    onClick={() => onDelete(bill.id)}
                                >
                                    <i className="ri-delete-bin-line"></i>
                                </Button>
                            </div>
                        </td>
                    </tr>
                ))}
                {bills.length === 0 && (
                    <tr>
                        <td colSpan="8" className="text-center py-4">
                            No bills found
                        </td>
                    </tr>
                )}
            </tbody>
        </Table>
    );
}; 